export * from './baContentTop.component';



// WEBPACK FOOTER //
// ./src/app/theme/components/baContentTop/index.ts